export default __webpack_public_path__ + "static/media/HyperComplexSem_template.e50ab325.tex";